<template>

  <b-modal :id="'modal-add-child'+item.id" :ref="'modal-add-child'" centered scrollable hide-header-close
           modal-class="menus-modal" @ok="onSubmit" @cancel="resetChild">
    <template #modal-header="{ cancel }">
      <menu-modal-header icon="diagram-3" title="اضافه کردن آیتم به زیرمجموعه"
                         :subtitle="`زیرمجموعه: ${item.name}`" @close="cancel()"/>
    </template>

    <form @submit.stop.prevent="onSubmit">

      <form-group :validations="$v.childItem.name">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>عنوان آیتم</label>
          <b-form-input type="text" v-model="childItem.name" placeholder="عنوان آیتم"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.childItem.url">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>آدرس اینترنتی</label>
          <b-form-input type="url" class="text-left" dir="ltr" v-model="childItem.url" placeholder="آدرس اینترنتی"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.childItem.color">
        <div slot-scope="{ errors, invalid }" class="menus-modal-field">
          <label>رنگ</label>
          <div class="menus-color-field">
            <b-form-input type="color" v-model="childItem.color"/>
            <code>{{ childItem.color }}</code>
          </div>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

    </form>

    <template #modal-footer="{ ok, cancel }">
      <div class="menus-modal-actions">
        <button type="button" class="menus-btn is-primary" @click="ok()">
          <b-icon icon="check2"></b-icon>
          <span>ثبت آیتم</span>
        </button>
        <button type="button" class="menus-btn" @click="cancel()">انصراف</button>
      </div>
    </template>
  </b-modal>

</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required,url} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import MenuModalHeader from './MenuModalHeader.vue'


export default {
  name: "CreateItemChildModalForm",
  props: ['item'],
  components:{ MenuModalHeader, FormGroup, FormErrorsManager},
  data() {
    return {
      childItem: {
        menu_id: parseInt(this.$route.params.id),
        target: this.item.target,
        order: this.item.order,
        parent_id: parseInt(this.item.id),
        name: '',
        url: '',
        icon_class: '',
        color: '#FFFFFF',
        status: 0,
      },
    }
  },
  validations: {
    childItem: {
      name: {required},
      url: {required,url},
      color: {required},
    },
  },
  methods: {
    checkIcon(){
      if(this.childItem.icon_class === ''){
        this.childItem.icon_class = 'ban'
      }else{
        this.childItem.icon_class = this.childItem.icon_class.name
      }
    },
    addChild() {
      this.checkIcon()
      this.$store.dispatch("Menu/createItem", this.childItem)
    },
    resetChild(){
      this.childItem = {
        menu_id: parseInt(this.$route.params.id),
        target: this.item.target,
        order: this.item.order,
        parent_id: parseInt(this.item.id),
        name: '',
        url: '',
        icon_class: '',
        color: '#FFFFFF',
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent){
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.addChild()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-add-child'+this.item.id)
          this.resetChild()
        })
      }
    }
  }
}
</script>
